<style scoped>
.printPage .page-title {
  font-size: 24px;
  font-weight: 600;
}
.page-title-txt {
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}
table {
  border-color: #000;
  border-spacing: 0px;
  line-height: 30px;
  width: 100%;
  border-top: none;
  border-left: none;
  text-align: left;
}
table tr td,
.tdBg {
  border-bottom: none;
  border-right: none;
  border-color: #bcbcbc;
  padding: 0 6px;
}
.tdBg {
  background: #f3f3f3;
}
.tdCenter {
  text-align: center;
  border-right: none;
}
.page-write {
  text-align: left;
  display: flex;
  width: 100%;
  height: 170px;
  border: 1px solid #000;
}
.page-write div {
  flex: 1;
  padding: 10px 100px 100px 10px;
}
.page-write div:first-child {
  border-right: 1px solid #000;
}
.page-break {
  page-break-after: always;
  margin-top: 20px;
  clear: both;
}
.print-section {
  page-break-inside: avoid;
}
</style>
<template>
  <div class="printPage">
    <el-dialog
      title="打印预览"
      :visible.sync="showPrintDialog"
      width="1000px"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div
        id="printBill"
        style="padding: 0 30px 0 30px; color: black; font-family: 宋体"
      >
        <!-- 付款通知书 -->
        <div v-if="showPaymentNotice" class="print-section">
          <h2 style="font-size: 24px !important; font-weight: 700">
            {{ paymentTitle }}
            <div style="font-size: 14px; font-weight: normal">
              （账单周期：{{ printData.accountMonthStartDate }}至{{
                printData.accountMonthEndDate
              }}）
            </div>
            <div v-if="billCycle" style="font-size: 14px; font-weight: normal">
              {{ billCycle }}
            </div>
          </h2>
          <p class="page-title-txt">致{{ printData.tenantName }}：</p>
          <p class="page-title-txt mb15">
            根据贵公司与我公司所签订的相关服务协议，请贵公司确认以下费用明细，并进行相关款项支付，谢谢。
          </p>
          <table border class="mb30" style="width: 100%">
            <tr>
              <td colspan="2" class="tdBg tdCenter" style="font-weight: bold">
                本期应付款汇总结算明细
              </td>
            </tr>
            <tr>
              <td class="tdBg" width="270">本期应付款合计金额（小写）：</td>
              <td class="t-right">
                {{ printData.currentPayAmount | numDigit | numFmt }}
              </td>
            </tr>
            <tr>
              <td class="tdBg" width="270">本期应付款合计（大写）：</td>
              <td class="t-right">
                {{ printData.currentPayAmount | smallToBig }}
              </td>
            </tr>
          </table>
          <table border class="mb30" style="width: 100%">
            <tr class="t-center">
              <th class="tdBg" width="55">序号</th>
              <th class="tdBg">任务类型</th>
              <th class="tdBg" width="80">数量</th>
              <th class="tdBg" width="130">单价</th>
              <th class="tdBg" width="80">计价单位</th>
              <th class="tdBg" width="130">金额(元)</th>
              <th class="tdBg" width="80">备注</th>
            </tr>
            <tr v-for="(item, index) in printData.detailList" :key="index">
              <td class="t-center">{{ index + 1 }}</td>
              <td>{{ item.taskContentName }}</td>
              <td class="t-right">{{ item.taskTotal }}</td>
              <td class="t-right">
                {{
                  item.settlePercent ? "-" : item.taskPrice | numDigit | numFmt
                }}
              </td>
              <td class="t-right">
                {{ item.settlePercent ? "-" : item.taskPriceUnit }}
              </td>
              <td class="t-right">{{ item.taskAmount | numDigit | numFmt }}</td>
              <td>
                {{
                  item.settlePercent
                    ? "固定比例，按照上游流向数据比对结果"
                    : item.note
                }}
              </td>
            </tr>
            <tr>
              <td colspan="5">合计任务金额</td>
              <td class="t-right">
                {{ printData.taskSumAmount | numDigit | numFmt }}
              </td>
              <td></td>
            </tr>
            <tr>
              <td colspan="5">考核评分</td>
              <td class="t-right">{{ getComprehensiveGrade() }}</td>
              <td></td>
            </tr>
            <tr v-show="printData.isContainServiceFee !== 'Y'">
              <td colspan="5">
                平台运营服务费（{{ printData.serviceFeeRate }}%）
              </td>
              <td class="t-right">
                {{ printData.serviceFee | numDigit | numFmt }}
              </td>
              <td></td>
            </tr>
            <tr
              v-show="
                printData.reportCoefficient != null &&
                printData.isContainServiceFee !== 'Y'
              "
            >
              <td colspan="5">数据服务费</td>
              <td class="t-right">
                {{ printData.dataServiceFee | numDigit | numFmt }}
              </td>
              <td></td>
            </tr>
            <tr>
              <td colspan="5">本期应付金额</td>
              <td class="t-right">
                {{ printData.currentPayAmount | numDigit | numFmt }}
              </td>
              <td></td>
            </tr>
          </table>
          <p class="page-title-txt mb15">支付账户信息如下：</p>
          <table border class="mb15" style="width: 100%">
            <tr>
              <td class="tdBg" width="170">开户名称：</td>
              <td class="t-left">{{ printData.serviceTenantName }}</td>
            </tr>
            <tr>
              <td class="tdBg" width="170">开户银行：</td>
              <td class="t-left">{{ printData.bankName }}</td>
            </tr>
            <tr>
              <td class="tdBg" width="170">银行账号：</td>
              <td class="t-left">{{ printData.bankAccount }}</td>
            </tr>
          </table>
          <div class="page-write">
            <div>申请单位（盖章）：</div>
            <div>审核单位（盖章）：</div>
          </div>
        </div>

        <!-- 推广计划确认单 / 服务项目预算确认单 -->
        <div v-if="showPromotionPlan" class="print-section page-break">
          <h2 style="font-size: 24px !important; font-weight: 700">
            {{ promotionTitle }}
            <div
              v-if="promotionType == 1"
              style="font-size: 14px; font-weight: normal"
            >
              (执行日期：{{ printData.accountMonthStartDate }}至{{
                printData.accountMonthEndDate
              }})
            </div>
            <div
              v-if="promotionType == 2"
              style="font-size: 14px; font-weight: normal"
            >
              （账单周期：{{ printData.accountMonthStartDate }}至{{
                printData.accountMonthEndDate
              }}）
            </div>
            <div
              v-if="promotionType == 2 && billCycle"
              style="font-size: 14px; font-weight: normal"
            >
              {{ billCycle }}
            </div>
          </h2>
          <p class="page-title-txt">致{{ printData.tenantName }}：</p>
          <p class="page-title-txt mb15">
            <template v-if="promotionType == 1"
              >根据贵公司与我公司所签订的相关服务协议，请贵公司确认以下推广计划，谢谢。</template
            >
            <template v-else
              >根据贵公司与我公司所签订的相关服务协议，请贵公司确认以下预算费用明细，谢谢。</template
            >
          </p>

          <!-- 推广计划特有内容 -->
          <template v-if="promotionType == 1">
            <div
              style="
                display: flex;
                justify-content: space-between;
                flex-wrap: nowrap;
              "
            >
              <p style="width: 48%; text-align: left">
                委托方：{{ printData.tenantName }}
              </p>
              <p style="width: 48%; text-align: right">
                服务方：{{ printData.serviceTenantName }}
              </p>
            </div>
            <div
              style="
                display: flex;
                justify-content: flex-start;
                flex-wrap: nowrap;
              "
            >
              <div style="width: 72px">任务标题：</div>
              <div style="width: 80%">
                <div
                  style="margin-bottom: 10px; text-align: left"
                  v-for="item in printData.taskInfoList"
                >
                  {{ item.name || "-" }}
                </div>
              </div>
            </div>
          </template>

          <!-- 服务项目预算特有内容 -->
          <template v-if="promotionType == 2">
            <table border class="mb30" style="width: 100%">
              <tr>
                <td colspan="2" class="tdBg tdCenter" style="font-weight: bold">
                  本期预付款汇总结算明细
                </td>
              </tr>
              <tr>
                <td class="tdBg" width="270">本期预付款合计金额（小写）：</td>
                <td class="t-right">
                  {{ getSumAmount(planData, 8) | numDigit | numFmt }}
                </td>
              </tr>
              <tr>
                <td class="tdBg" width="270">本期预付款合计（大写）：</td>
                <td class="t-right">
                  {{ getSumAmount(planData, 8) | smallToBig }}
                </td>
              </tr>
            </table>
          </template>

          <!-- 表格内容 -->
          <table border class="mb30" style="width: 100%">
            <tr class="t-center">
              <th class="tdBg" width="55">序号</th>
              <th class="tdBg" :width="promotionType == 1 ? '100' : ''">
                任务类型
              </th>
              <th class="tdBg" width="100">数量</th>
              <th class="tdBg" width="130">
                {{ promotionType == 1 ? "价格" : "单价" }}
              </th>
              <th v-if="promotionType == 2" class="tdBg" width="80">
                计价单位
              </th>
              <th v-if="promotionType == 2" class="tdBg" width="130">
                金额(元)
              </th>
              <th v-if="promotionType == 1" class="tdBg">任务描述</th>
            </tr>
            <tr v-for="(item, index) in planData" :key="index">
              <td class="t-center">{{ index + 1 }}</td>
              <td>{{ item.taskContentName }}</td>
              <td class="t-right" style="white-space: nowrap">
                <template v-if="promotionType == 1">
                  <div
                    v-if="
                      item.taskTotalType != '固定量人均' &&
                      item.taskTotalType != '不限量'
                    "
                    style="
                      display: flex;
                      align-items: center;
                      text-align: right;
                      justify-content: flex-end;
                    "
                  >
                    <div>{{ item.taskTotal }}</div>
                    <span style="margin-left: 4px">{{
                      item.taskTotalUnit
                    }}</span>
                  </div>
                  <div
                    v-if="item.taskTotalType == '固定量人均'"
                    style="
                      display: flex;
                      align-items: center;
                      text-align: right;
                      justify-content: flex-end;
                    "
                  >
                    <div>{{ item.taskAvg }}</div>
                    <span style="margin-left: 4px">{{
                      item.taskTotalUnit
                    }}</span>
                  </div>
                  <div
                    v-if="item.taskTotalType == '不限量'"
                    style="
                      display: flex;
                      align-items: center;
                      text-align: right;
                      justify-content: flex-end;
                    "
                  >
                    <div>不限量</div>
                  </div>
                </template>
                <template v-else>
                  {{
                    item.taskTotalType == "不限量" ? "不限量" : item.taskTotal
                  }}
                </template>
              </td>
              <td class="t-right">
                <template v-if="promotionType == 1"
                  >{{ item.tenantTaskPrice }}
                  {{ item.tenantTaskPriceUnit }}</template
                >
                <template v-else>{{
                  item.tenantTaskPrice | numDigit | numFmt
                }}</template>
              </td>
              <td v-if="promotionType == 2" class="t-right">
                {{ item.tenantTaskPriceUnit }}
              </td>
              <td v-if="promotionType == 2" class="t-right">
                {{ item.taskAmount | numDigit | numFmt }}
              </td>
              <td v-if="promotionType == 1">{{ getTenantTaskNote(item) }}</td>
            </tr>
            <tr v-if="promotionType == 2">
              <td colspan="5">合计任务金额</td>
              <td class="t-right">
                {{ getSumAmount(planData, 8) | numDigit | numFmt }}
              </td>
            </tr>
          </table>

          <!-- 服务项目预算特有内容 -->
          <template v-if="promotionType == 2">
            <p class="page-title-txt mb15">支付账户信息如下：</p>
            <table border class="mb15" style="width: 100%">
              <tr>
                <td class="tdBg" width="170">开户名称：</td>
                <td class="t-left">{{ printData.serviceTenantName }}</td>
              </tr>
              <tr>
                <td class="tdBg" width="170">开户银行：</td>
                <td class="t-left">{{ printData.bankName }}</td>
              </tr>
              <tr>
                <td class="tdBg" width="170">银行账号：</td>
                <td class="t-left">{{ printData.bankAccount }}</td>
              </tr>
            </table>
          </template>

          <div class="page-write">
            <div>申请单位（盖章）：</div>
            <div>审核单位（盖章）：</div>
          </div>
        </div>

        <!-- 推广服务验收单 -->
        <div v-if="showReceipt" class="print-section page-break">
          <table
            class="excel-main"
            style="width: 100%; border-collapse: collapse"
          >
            <thead>
              <tr>
                <th
                  colspan="2"
                  style="
                    border: 1px solid #000;
                    padding: 10px 20px 10px 8px;
                    font-size: 24px;
                    font-weight: bold;
                    text-align: center;
                  "
                >
                  推广服务验收单
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="item">
                <td
                  class="item-label"
                  style="
                    border: 1px solid #000;
                    width: 280px;
                    text-align: center;
                    padding: 10px 20px 10px 8px;
                    font-size: 14px;
                  "
                >
                  服务方
                </td>
                <td
                  class="item-content"
                  style="
                    border: 1px solid #000;
                    padding: 10px 20px 10px 8px;
                    font-size: 14px;
                  "
                >
                  {{ printData.serviceTenantName }}
                </td>
              </tr>
              <tr class="item">
                <td
                  class="item-label"
                  style="
                    border: 1px solid #000;
                    width: 280px;
                    text-align: center;
                    padding: 10px 20px 10px 8px;
                    font-size: 14px;
                  "
                >
                  验收方
                </td>
                <td
                  class="item-content"
                  style="
                    border: 1px solid #000;
                    padding: 10px 20px 10px 8px;
                    font-size: 14px;
                  "
                >
                  {{ printData.tenantName }}
                </td>
              </tr>
              <tr class="item">
                <td
                  class="item-label"
                  style="
                    border: 1px solid #000;
                    width: 280px;
                    text-align: center;
                    padding: 10px 20px 10px 8px;
                    font-size: 14px;
                  "
                >
                  服务时间
                </td>
                <td
                  class="item-content"
                  style="
                    border: 1px solid #000;
                    padding: 10px 20px 10px 8px;
                    font-size: 14px;
                  "
                >
                  {{ printData.accountMonthStartDate }}至{{
                    printData.accountMonthEndDate
                  }}（第{{
                    printData.billCycleList && printData.billCycleList.join()
                  }}）
                </td>
              </tr>
              <tr class="item">
                <td
                  class="item-label"
                  style="
                    border: 1px solid #000;
                    width: 280px;
                    text-align: center;
                    padding: 10px 20px 10px 8px;
                    font-size: 14px;
                  "
                >
                  服务金额
                </td>
                <td
                  class="item-content"
                  style="
                    border: 1px solid #000;
                    padding: 10px 20px 10px 8px;
                    font-size: 14px;
                  "
                >
                  大写：<span style="text-decoration: underline">{{
                    printData.currentPayAmount | smallToBig
                  }}</span
                  >， 小写：<span style="text-decoration: underline">{{
                    printData.currentPayAmount | numDigit | numFmt
                  }}</span>
                </td>
              </tr>
              <tr class="item">
                <td
                  class="item-label"
                  style="
                    border: 1px solid #000;
                    width: 280px;
                    text-align: center;
                    padding: 10px 20px 10px 8px;
                    font-size: 14px;
                  "
                >
                  服务交付类型和数量
                </td>
                <td
                  class="item-content"
                  style="
                    border: 1px solid #000;
                    padding: 10px 20px 10px 8px;
                    font-size: 14px;
                  "
                >
                  <p
                    v-for="(item, index) in printData.detailList"
                    :key="item.guid"
                  >
                    {{ getChineseNum(index + 1) }}、{{ item.taskContentName }}
                    {{ item.taskTotal }} {{ item.taskTotalUnit }}
                  </p>
                </td>
              </tr>
              <tr class="item">
                <td
                  class="item-label"
                  style="
                    border: 1px solid #000;
                    width: 280px;
                    text-align: center;
                    padding: 10px 20px 10px 8px;
                    font-size: 14px;
                  "
                >
                  服务验收结论
                </td>
                <td
                  class="item-content"
                  style="
                    border: 1px solid #000;
                    padding: 10px 20px 10px 8px;
                    font-size: 14px;
                  "
                >
                  <div style="margin-bottom: 20px">
                    <div style="margin-top: 10px; font-weight: bold">
                      服务方意见（盖章）：
                    </div>
                    <div style="margin: 20px 0; text-indent: 2em">
                      根据验收方服务要求，已完成推广服务事项具体内容实施，并提供相应服务报告，确认该服务完成，顺利交付。
                    </div>
                    <div style="text-align: right">
                      <span>{{ receiptYear }}</span
                      >年 <span style="margin: 0 10px">{{ receiptMonth }}</span
                      >月 <span style="margin: 0 10px">{{ receiptDay }}</span
                      >日
                    </div>
                  </div>
                  <div>
                    <div style="margin-top: 10px; font-weight: bold">
                      验收方意见（盖章）：
                    </div>
                    <div style="margin: 20px 0; text-indent: 2em">
                      验收方已收到服务方提供的服务报告，符合我方服务要求，确认该服务完成，顺利验收。
                    </div>
                    <div style="text-align: right">
                      <span>{{ receiptYear }}</span
                      >年 <span style="margin: 0 10px">{{ receiptMonth }}</span
                      >月 <span style="margin: 0 10px">{{ receiptDay }}</span
                      >日
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closePrint" style="color: #4fa1a4"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="billPrintClick"
          style="color: #fff"
          >打 印</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import printJS from "@/assets/js/print.min.js";
import Decimal from "decimal.js"
export default {
  name: "printCombine",
  props: {
    showPrintDialog: {
      type: Boolean,
      default: false,
    },
    printData: {
      type: Object,
      default: {},
    },
    planData: {
      type: Array,
      default: [],
    },
    paymentTitle: {
      type: String,
      default: "付款通知书",
    },
    promotionTitle: {
      type: String,
      default: "推广计划确认单",
    },
    promotionType: {
      type: Number,
      default: 1,
    },
    showPaymentNotice: {
      type: Boolean,
      default: true,
    },
    showPromotionPlan: {
      type: Boolean,
      default: false,
    },
    showReceipt: {
      type: Boolean,
      default: false,
    },
    billCycle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      sendCopy: "",
      staffName: null,
      receiptYear: null,
      receiptMonth: null,
      receiptDay: null,
    };
  },
  created() {
    let userInfo = JSON.parse(localStorage.userInfo);
    this.staffName = userInfo.staffName;
    // 获取验收单日期
    if (this.printData.accountMonthEndDate) {
      const [year, month, day] = this.printData.accountMonthEndDate
        .split("-")
        .map((item) => parseInt(item));
      this.receiptYear = year;
      this.receiptMonth = month;
      this.receiptDay = day;
    }
  },
  methods: {
    // 工业考核得分
    getComprehensiveGrade() {
      if (!this.printData || this.printData.comprehensiveGrade === null || this.printData.comprehensiveGrade === undefined) {
        return '-';
      }
      const score = Number(this.printData.comprehensiveGrade) * 100;
      if (this.printData.scoreRule == 1) {
        return this.ceilToTwoDecimals(score);
      }
      return score.toFixed(2);
    },
    // 保留两位小数 向上进一
    ceilToTwoDecimals(num) {
      const value = new Decimal(num);
      const floorToTwoDecimals = value.times(100).floor().dividedBy(100);
      if (floorToTwoDecimals.greaterThanOrEqualTo(100)) {
        return floorToTwoDecimals.toFixed(2);
      }
      return floorToTwoDecimals.plus(0.01).toFixed(2);
    },
    getTenantTaskNote(detail) {
      const { taskTotalType, taskTotal, tenantTaskNote } = detail;
      if (taskTotalType == "固定量人均" || taskTotalType == "系统计算") {
        return tenantTaskNote?.replace("#总任务量#", taskTotal) || "";
      }
      return ""; // 或其他默认值
    },
    getSumAmount(list, type) {
      let sum = 0;
      if (type == 8) {
        if (!list || list.length < 1) return 0;
        list.forEach((item) => {
          sum += Math.round(item.taskAmount * 100) / 100;
        });
      }
      return sum;
    },
    getChineseNum(value) {
      const numMap = {
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六",
        7: "七",
        8: "八",
        9: "九",
        10: "十",
        11: "十一",
        12: "十二",
        13: "十三",
        14: "十四",
        15: "十五",
        16: "十六",
        17: "十七",
        18: "十八",
        19: "十九",
        20: "二十",
      };
      return numMap[value] || value;
    },
    closePrint() {
      this.$emit("closePrint");
    },
    billPrintClick() {
      printJS({
        printable: "printBill",
        type: "html",
        header: "",
        documentTitle: "",
        targetStyles: ["*"],
        scanStyles: true,
      });
      this.closePrint();
    },
  },
};
</script>
